import React, { useRef, useState } from 'react';
import { Dialog, T, useTranslation } from '@colonist/ui';
import { TextInput } from '@colonist/ui-platform';
import { MIN_USERNAME_LENGTH, MAX_USERNAME_LENGTH } from '@colonist/consts';
import { isValueStringBetween } from '@colonist/validation';
/** Dialog that accepts a player name and submits it for leaderboard filtering. */ export const PlayerFilterDialog = ({ open, onClose, onSearch })=>{
    const { t } = useTranslation();
    const inputRef = useRef(null);
    const [isValid, setIsValid] = useState(false);
    const handleSearch = ()=>{
        if (!isValid) return;
        if (!inputRef.current) return;
        onSearch(inputRef.current.value);
        onClose();
    };
    const handleInput = (event)=>{
        setIsValid(isValueStringBetween(event.target.value, MIN_USERNAME_LENGTH, MAX_USERNAME_LENGTH));
    };
    const handleKeyDown = (event)=>{
        if (event.key == 'Enter') {
            event.preventDefault();
            handleSearch();
        }
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: "strings:popups.searchPlayer.title"
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement(TextInput, {
        ref: inputRef,
        placeholder: t('strings:popups.searchPlayer.placeholder'),
        onChange: handleInput,
        onKeyDown: handleKeyDown,
        autoFocus: true
    })), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: onClose
    }), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        disabled: !isValid,
        onClick: handleSearch
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:popups.searchPlayer.checkButton"
    }))));
};
